export function getErrorMessages(error, intlValues) {

  const regex = /Booking date:\s*(.+?)\s*is not within the schedule range:\s*(\d{4}-\d{2}-\d{2})\s*-\s*(\d{4}-\d{2}-\d{2})/;
  const match = error.match(regex);

  if (error === 'Received invalid value for date, should be a future date') {
    return {
      intl: 'submitResourceInvalidDate',
    };
  } if (error.includes('is not within the schedule range')) {

    const bookingDate = match[1];
    const startDate = match[2];
    const endDate = match[3];

    return {
      intl: 'submitResourceNotWithinScheduleRange',
      intlValues: { date: bookingDate, startDate, endDate },
    };
  } if (error.includes('Booking overlaps with existing booking for the resource')) {

    return {
      intl: 'submitResourceBookingOverlap',
      intlValues,
    };
  }

  return {
    intl: 'submitResourceError',
  };
}

